import styled from 'styled-components';

export const Groups = styled.div`
  padding: 0 16px 16px;
  font-size: 13px;
  color: #262626;
`;

export const GroupName = styled.h3`
  padding: 14px 0 4px;
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  color: #8c8c8c;
  text-transform: uppercase;
  letter-spacing: 0.06em;
`;

export const Rows = styled.dl`
  margin: 0;
`;

export const Row = styled.div`
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 7px 0;
  border-bottom: 1px solid #f0f0f0;
`;

export const Label = styled.dt`
  flex: none;
  font-weight: 400;
  color: #595959;
`;

export const Value = styled.dd`
  min-width: 0;
  margin: 0;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  text-align: right;
  overflow-wrap: anywhere;
`;
